import React, { useState } from 'react';
import { Dialog, DialogContent, DialogHeader, DialogTitle, DialogDescription } from '@/components/ui/dialog';
import { User, Building2, ArrowRight } from 'lucide-react';

const RoleSelectionModal = ({ open, onClose, onRoleSelected }) => {
  const [action, setAction] = useState(null); // 'login' or 'register'

  const handleSelection = (role, actionType) => {
    onRoleSelected(role, actionType);
    onClose();
  };

  if (!action) {
    return (
      <Dialog open={open} onOpenChange={onClose}>
        <DialogContent className="max-w-md">
          <DialogHeader>
            <DialogTitle className="text-2xl font-bold text-slate-900 text-center">
              Benvenuto su TravelDiscount
            </DialogTitle>
            <DialogDescription className="text-slate-600 text-center">
              Cosa vuoi fare?
            </DialogDescription>
          </DialogHeader>

          <div className="space-y-3 mt-6">
            <button
              onClick={() => setAction('login')}
              className="w-full p-4 rounded-xl border-2 border-blue-200 hover:border-blue-500 hover:bg-blue-50 transition-all group"
            >
              <div className="flex items-center justify-between">
                <span className="font-semibold text-slate-900">Accedi</span>
                <ArrowRight className="w-5 h-5 text-blue-600 group-hover:translate-x-1 transition-transform" />
              </div>
              <p className="text-sm text-slate-600 text-left mt-1">Ho già un account</p>
            </button>

            <button
              onClick={() => setAction('register')}
              className="w-full p-4 rounded-xl border-2 border-emerald-200 hover:border-emerald-500 hover:bg-emerald-50 transition-all group"
            >
              <div className="flex items-center justify-between">
                <span className="font-semibold text-slate-900">Registrati</span>
                <ArrowRight className="w-5 h-5 text-emerald-600 group-hover:translate-x-1 transition-transform" />
              </div>
              <p className="text-sm text-slate-600 text-left mt-1">Crea un nuovo account</p>
            </button>
          </div>
        </DialogContent>
      </Dialog>
    );
  }

  return (
    <Dialog open={open} onOpenChange={onClose}>
      <DialogContent className="max-w-2xl">
        <DialogHeader>
          <DialogTitle className="text-2xl font-bold text-slate-900 text-center">
            {action === 'login' ? 'Accedi come...' : 'Registrati come...'}
          </DialogTitle>
          <DialogDescription className="text-slate-600 text-center">
            Seleziona il tipo di account
          </DialogDescription>
        </DialogHeader>

        <div className="grid grid-cols-1 md:grid-cols-2 gap-4 mt-6">
          {/* Traveler */}
          <button
            onClick={() => handleSelection('traveler', action)}
            className="group relative overflow-hidden rounded-2xl p-8 transition-all hover:scale-105 hover:shadow-2xl bg-gradient-to-br from-blue-500 to-blue-600 border-4 border-blue-400/30 shadow-xl shadow-blue-500/30"
          >
            <div className="absolute inset-0 bg-gradient-to-br from-white/20 to-transparent opacity-0 group-hover:opacity-100 transition-opacity"></div>
            <div className="relative flex flex-col items-center gap-4 text-white">
              <div className="w-20 h-20 bg-white/30 backdrop-blur-sm rounded-full flex items-center justify-center">
                <User className="w-10 h-10 text-white" strokeWidth={2.5} />
              </div>
              <div className="text-center">
                <p className="font-bold text-lg mb-1">Sono un Viaggiatore</p>
                <p className="text-sm text-blue-100">Cerca e prenota offerte last-minute</p>
              </div>
            </div>
          </button>

          {/* Property Owner */}
          <button
            onClick={() => handleSelection('property', action)}
            className="group relative overflow-hidden rounded-2xl p-8 transition-all hover:scale-105 hover:shadow-2xl bg-gradient-to-br from-orange-500 to-orange-600 border-4 border-orange-400/30 shadow-xl shadow-orange-500/30"
          >
            <div className="absolute inset-0 bg-gradient-to-br from-white/20 to-transparent opacity-0 group-hover:opacity-100 transition-opacity"></div>
            <div className="relative flex flex-col items-center gap-4 text-white">
              <div className="w-20 h-20 bg-white/30 backdrop-blur-sm rounded-full flex items-center justify-center">
                <Building2 className="w-10 h-10 text-white" strokeWidth={2.5} />
              </div>
              <div className="text-center">
                <p className="font-bold text-lg mb-1">Sono un Proprietario</p>
                <p className="text-sm text-orange-100">Gestisci la tua struttura</p>
              </div>
            </div>
          </button>
        </div>

        <button
          onClick={() => setAction(null)}
          className="text-sm text-slate-500 hover:text-slate-700 mt-4 mx-auto block"
        >
          ← Indietro
        </button>
      </DialogContent>
    </Dialog>
  );
};

export default RoleSelectionModal;
